module.exports = __webpack_public_path__ + "static/img/eu.4ca56384.svg";